import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
//amplify
import Amplify, * as AmplifyModules from 'aws-amplify'
import {AmplifyPlugin } from 'aws-amplify-vue'
import { /*components,*/ AmplifyEventBus } from 'aws-amplify-vue';
//
import AmplifyStore from './store/store';
import Impressum from './components/Impressum.vue'
import Privacy from './components/Privacy.vue'
import Home from './components/Home.vue'
import Subscribe from './components/Subscribe'
import BootstrapVue from 'bootstrap-vue'
import Auth from './components/Auth.vue'






Amplify.configure({
  Auth: {

      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      //identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
      //identityPoolId: 'eu-central-1_ne60s9DQy',

      // REQUIRED - Amazon Cognito Region
      region: 'eu-central-1',

      // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
      // Required only if it's different from Amazon Cognito Region
      identityPoolRegion: 'eu-central-1',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'eu-central-1_ne60s9DQy',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '61nps3sbkg5vcrn4vl5hduqbf4',

      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      //mandatorySignIn: false,

      // OPTIONAL - Configuration for cookie storage
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
      //cookieStorage: {
      // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      //    domain: '.yourdomain.com',
      // OPTIONAL - Cookie path
      //    path: '/',
      // OPTIONAL - Cookie expiration in days
      //    expires: 365,
      // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
       //   sameSite: "strict" | "lax",
      // OPTIONAL - Cookie secure flag
      // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
       //   secure: true
      //},

      // OPTIONAL - customized storage object
      //storage: MyStorage,

      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      //authenticationFlowType: 'USER_PASSWORD_AUTH',

      // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
      //clientMetadata: { myCustomKey: 'myCustomValue' },

      // OPTIONAL - Hosted UI configuration
      /*oauth: {
          domain: 'your_cognito_domain',
          scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: 'http://localhost:3000/',
          redirectSignOut: 'http://localhost:3000/',
          responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
      }*/
  }
});

// You can get the current config object
//const currentConfig = Auth.configure();
//bla bla

Amplify.I18n.setLanguage('de');



Vue.use(AmplifyPlugin,  AmplifyModules)

let user;

getUser().then((user /*, error*/) => {
  if (user) {
    router.push({ path: '/' })
  }
})


AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    user = null;
    AmplifyStore.commit('setUser', null);
    router.push({ path: '/auth' })
  } else if (state === 'signedIn') {
    user = await getUser();
    router.push({ path: '/profile' })
  }
});

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      AmplifyStore.commit('setUser', data);
      return data;
    }
  }).catch((/*e*/) => {
    AmplifyStore.commit('setUser', null);
    return null
  });
}



Vue.use(BootstrapVue);

Vue.use(Router);

Vue.config.productionTip = false

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Impressum
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  }
]

const router = new Router({ routes })

//components.Authenticator
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        }
      });
    }
    return next()
  }
  return next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
